import { CloudRain, Thermometer, Wind } from 'lucide-react';
import type { ForecastDaySummary, ForecastVariable } from './WeatherDashboard';

export interface WeatherVariableDef {
  id: ForecastVariable;
  label: string;
  unit: string;
  icon: React.ReactNode;
  iconClass: string;
  pillClass: string;
  read: (day?: ForecastDaySummary) => string;
  readShort: (day?: ForecastDaySummary) => string;
}

export const WEATHER_VARIABLES: WeatherVariableDef[] = [
  {
    id: 'temp',
    label: 'Temp',
    unit: '°C',
    icon: <Thermometer size={15} strokeWidth={2.25} />,
    iconClass: 'text-orange-600 dark:text-orange-400',
    pillClass:
      'border-orange-200 bg-orange-50 dark:border-orange-900/50 dark:bg-orange-950/30',
    read: (day) => (day?.temperature_c != null ? `${Math.round(day.temperature_c)}°` : '—'),
    readShort: (day) => (day?.temperature_c != null ? `${Math.round(day.temperature_c)}°` : '—'),
  },
  {
    id: 'precip',
    label: 'Rain',
    unit: 'mm',
    icon: <CloudRain size={15} strokeWidth={2.25} />,
    iconClass: 'text-sky-600 dark:text-sky-400',
    pillClass: 'border-sky-200 bg-sky-50 dark:border-sky-900/50 dark:bg-sky-950/30',
    read: (day) => (day?.precipitation_mm != null ? `${day.precipitation_mm.toFixed(0)}` : '—'),
    readShort: (day) => (day?.precipitation_mm != null ? `${day.precipitation_mm.toFixed(0)} mm` : '—'),
  },
  {
    id: 'wind',
    label: 'Wind',
    unit: 'm/s',
    icon: <Wind size={15} strokeWidth={2.25} />,
    iconClass: 'text-violet-600 dark:text-violet-400',
    pillClass:
      'border-violet-200 bg-violet-50 dark:border-violet-900/50 dark:bg-violet-950/30',
    read: (day) => (day?.wind_speed_ms != null ? day.wind_speed_ms.toFixed(1) : '—'),
    readShort: (day) => (day?.wind_speed_ms != null ? `${day.wind_speed_ms.toFixed(1)} m/s` : '—'),
  },
];
